import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('overlay', ['visible']),
    classObject() {
      return { 'overlay--visible': this.visible };
    },
  },
  methods: {
    ...mapActions('overlay', ['hide']),
  },
};



// WEBPACK FOOTER //
// ./src/components/generics/overlay/overlay.js